import React from 'react';
import { AvpDgaFeatureAppDependencies } from '@/index';

export const FeatureServicesContext = React.createContext<AvpDgaFeatureAppDependencies | undefined>(
  undefined,
);

export function useFeatureServices(): AvpDgaFeatureAppDependencies {
  const featureServices = React.useContext(FeatureServicesContext);

  if (!featureServices) {
    throw new Error('No featureServices context value was provided.');
  }

  return featureServices;
}
